import React, { useCallback, useEffect, useRef } from 'react';
import UserPicker from '@atlassian/jira-base-user-picker/src/main.tsx';
import type { UserOption } from '@atlassian/jira-base-user-picker/src/types.tsx';
import { mapUserObjectToUserOption } from '@atlassian/jira-base-user-picker/src/utils.tsx';
import { REPORTER_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { useCurrentUser } from '@atlassian/jira-platform-services-user-current/src/main.tsx';
import type { Props } from './types.tsx';
import { fetchSuggestions } from './utils.tsx';

const ReporterEdit = (props: Props): React.JSX.Element => {
	const {
		allowEmail = false,
		appearance,
		width,
		onChange,
		onSelection,
		value = null,
		autoFocus = false,
		placeholder = '',
		isDisabled = false,
		autoCompleteUrl,
		onCancel,
		isClearable = true,
		fetchSuggestions: fetchSuggestionsProps,
		shouldSetDefaultValue: shouldSetDefaultValueProp = true,
		openMenuOnClick = false,
		...fieldProps
	} = props;

	const {
		data: { user },
	} = useCurrentUser();

	const shouldSetDefaultValue = useRef(!value && shouldSetDefaultValueProp);

	// to store default value in form field wrapper if value is not set
	useEffect(() => {
		if (shouldSetDefaultValue.current && user && !value) {
			shouldSetDefaultValue.current = false;
			// eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
			onChange(mapUserObjectToUserOption(user, true));
		}
	}, [onChange, user, value]);

	const fetchSuggestionsCallback = useCallback(
		async (query: string | null): Promise<UserOption[]> => fetchSuggestions(autoCompleteUrl, query),
		[autoCompleteUrl],
	);

	return (
		<UserPicker
			{...fieldProps}
			appearance={appearance}
			width={width}
			fieldId={REPORTER_TYPE}
			autoCompleteUrl={autoCompleteUrl}
			// @ts-expect-error TS2322: Type (arg1: UserOption) => void is not assignable to type (arg1: UserOption | UserOption[]) => void
			onChange={onChange}
			value={value}
			autoFocus={autoFocus}
			placeholder={placeholder}
			isDisabled={isDisabled}
			fetchSuggestions={fetchSuggestionsProps || fetchSuggestionsCallback}
			onSelection={onSelection}
			onCancel={onCancel}
			isClearable={isClearable}
			allowEmail={allowEmail}
			shouldShowEmailInOptions
			openMenuOnClick={openMenuOnClick}
			aria-labelledby={fieldProps['aria-labelledby']}
		/>
	);
};

export default ReporterEdit;
